import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useIsMobileVariant } from '@dhl-ui/components'
import { PageWithRefresh, type PageMenuItem } from '@dhl-ui/page'
import { type PageResponsiveProps, PageResponsive as ReceiverPageResponsive } from '@dhl/receiver-page'
import { PromotionDialog } from '~/components/PromotionDialog.js'
import { useMenuItems } from './use-menu-items.js'
import { EndNode } from './EndNode.js'
import { HeaderContent } from './HeaderContent.js'

/**
 * SubPage for the portal where it sets the correct page for our supported variants
 */
export const PortalSubPage: FC<PageResponsiveProps> = ({ children, ...props }) => {
  const navigate = useNavigate()
  const isMobileVariant = useIsMobileVariant()

  const handleMenuSelect = (item: PageMenuItem) => {
    navigate(item.link)
  }

  const menuItems = useMenuItems()

  return (
    <ReceiverPageResponsive
      sideMenu={
        !isMobileVariant ? (
          <PageWithRefresh.SideMenu items={menuItems} onSelect={handleMenuSelect} endNode={<EndNode />} />
        ) : undefined
      }
      bottomMenu={
        isMobileVariant ? <PageWithRefresh.BottomMenu items={menuItems} onSelect={handleMenuSelect} /> : undefined
      }
      header={<PageWithRefresh.Header endNode={<HeaderContent />} />}
      endNode={<PromotionDialog />}
      {...props}
    >
      {children}
    </ReceiverPageResponsive>
  )
}
